'use strict'

import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js'
import { html } from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: 'moskito-avatar',
  _template: html`
<style>
  :host {
    --paper-avatar-width: 40px;
    --paper-avatar-font-ratio: 0.6;
  }

  :host {
    display: inline-block;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    width: var(--paper-avatar-width);
    height:  var(--paper-avatar-width);
    border-radius: 50%;
    cursor: default;
    background-color: var(--paper-avatar-color, var(--paper-avatar-bgcolor));
    -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
  }

  :host > * {
    pointer-events: none;
  }

  #label, #img {
    position: absolute;
    top: -5%;
    left: -5%;
    right: -5%;
    bottom: -5%;
    width: 110%;
    height: 110%;
    border-radius: 50%;
  }

  #label {
    overflow: hidden;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
      -ms-flex-direction: row;
        flex-direction: row;
    -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
  }

  #label span {
    display: block;
    width: 100%;
    font-weight: 100;
    color: rgba(255, 255, 255, .8);
    text-transform: uppercase;
    -webkit-font-smoothing: antialiased;
    text-align: center;
    font-size: calc(var(--paper-avatar-width) * var(--paper-avatar-font-ratio) * 0.8);
  }

  *[hidden] {
    display: none !important;
  }
</style>

<div id='label' title='[[label]]'><span>[[_label(label)]]</span></div>

<template is='dom-if' if='_hasImg'>
  <img id='img' src='[[src]]' on-load='_onImgLoad' on-error='_onImgError' title='[[color]]'>
</template>`,
  properties: {
    /**
     * Image address or base64
     */
    src: {
      type: String
    },
    /**
     * Label with username
     */
    label: {
      type: String,
      observer: '_observerLabel'
    },
    /**
     * Show two chars in avatar
     */
    twoChars: {
      type: Boolean,
      value: false
    },
    /**
     * Array of colors for avatar background
     */
    colors: {
      type: Array
    }
  },
  _observerLabel: function (label) {
    if (label) {
      this.updateStyles({
        '--paper-avatar-bgcolor': this._parseColor(label)
      })
    }
  },
  _label: function (label) {
    if (!label || /^ *$/.test(label)) {
      return ''
    }
    if (this.twoChars) {
      if (this.label.indexOf(' ') > -1) {
        const matches = this.label.match(/\b(\w)/g)
        return matches[0] + matches[1]
      } else {
        return label.substring(0, 2)
      }
    }
    return label.charAt(0)
  },
  _onImgLoad: function (e) {
    e.currentTarget.hidden = false
  },
  _onImgError: function (e) {
    e.currentTarget.hidden = true
  },
  _parseColor: function (label) {
    var colors = this.colors ? this.colors : ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#795548', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722', '#9E9E9E', '#607D8B']
    var hash = 0
    for (var a = 0; a < label.length; a++) {
      hash += (label.charCodeAt(a) << 5)
    }
    if (hash >= colors.length) {
      return colors[hash % colors.length]
    }
    return colors[hash]
  }
})
